import React from 'react';
import styled from 'styled-components';

import { Paper, Typography } from '@material-ui/core';

import IconArrow from '../../assets/icon-arrow.svg';
import IconLoadPeakShaving from '../../assets/icon-load-peak-shaving.svg';

const Root = styled(Paper)`
	height: 100%;
	padding: 20px;
	cursor: pointer;

	.tile-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;

		h5 {
			font-size: 16px;
			font-weight: bold;
			text-transform: uppercase;
		}

		img {
			width: 30px;
		}
	}

	.tile-content {
		display: flex;
		align-items: center;
		margin-top: 50px;

		img {
			height: 60px;
			margin: 0 10% 0 5%;
		}
	}
`;

const TileNetzentgeltOptimierung = ({ toggleModal }) => (
	<Root onClick={toggleModal}>
		<div className="tile-head">
			<Typography variant="h5">Netzentgeltoptimierung</Typography>
			<img src={IconArrow} alt="" />
		</div>
		<div className="tile-content">
			<img
				src={IconLoadPeakShaving}
				alt="Netzentgeltoptimierung durch Lastspitzkappung"
			/>
			<Typography variant="body2">
				Eine maximale Senkung Ihrer Energiekosten lässt sich durch
				Lastspitzenkappung erreichen.
			</Typography>
		</div>
	</Root>
);

export default TileNetzentgeltOptimierung;
